/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState, useRef, useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import {
  caseEditAction,
  caseResetAction,
  caseSearchAction,
} from "../case-container/actions/CaseActions";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import OpenNewTabLink from "src/components/OpenNewTabLink";
import { userSearchAPI } from "src/api/UserApi";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CommissionManagerDropDown from "src/business-components/CommissionManagerDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { PAYOUT } from "../company-container/CompanyConstants";
import FormikCheckBox from "src/components/formik/FormikCheckBox";
import { caseInvoiceCreateAPI, pipelineApi } from "src/api/CaseApi";
import LinkComponent from "src/components/LinkComponent";
import { Route, Switch } from "react-router-dom";
import Invoice from "./Invoice";
import { useHistory } from "react-router";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { commissionSearchAPI } from "src/api/CommissionApi";
import CustomerDropDown from "src/business-components/CustomerDropDown";
import FormikInput from "src/components/formik/FormikInput";
import { getGSTCalc, getPayout, getTotalAmount } from "src/utils/CommonUtils";
import { EMPLOYMENT_TYPES_LIST } from "../user-container/UserConstants";
import { DATA_TYPE, DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { remarkSearchAPI } from "src/api/RemarkApi";
import { ExportReactCSV } from "src/components/excel/ExportReactCSV";
import { excelCaseSearchAction } from "../excel-container/actions/ExcelActions";

const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    values,
    activityList,
    userType,
    ExportInExcel,
    handleChange,
    generateInvoice,
    history,
    onPageChange,
    alertModalClass,
    alertDisplay,
    openAlertDialog,
    viewRemarks,
    editClick,
    grossLoan,
    netLoan,
    total,
  } = props;

  //Deepcopy of EMPLOYMENT_TYPES_LIST
  const Employment_List = JSON.parse(JSON.stringify(EMPLOYMENT_TYPES_LIST));
  Employment_List.push({
    value: 'onroll&dsa',
    label: 'Onroll&DSA',
  });

  return (
    <div>
      <div style={{ justifyContent: 'center', display: 'flex', padding: '20px' }}><h2>Case List</h2></div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Category</label>
                <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  name="productCategory"
                  className="form-control"
                />
              </div>
              {values.productCategory === "CAR_LOAN" && (
                <div className="form-group col-md-3">
                  <label>Loan Type</label>
                  <FormikSelect
                    items={CAR_LOAN_TYPE_LIST}
                    name="loanType"
                    className="form-control"
                  />
                </div>
              )}
              {values.productCategory === "CAR_LOAN" && values.loanType === "USED" && (
                <div className="form-group col-md-3">
                  <label>Used Car Loan Type</label>
                  <FormikSelect
                    items={USED_CAR_LOAN_TYPE_LIST}
                    name="usedCarLoanType"
                    className="form-control"
                  />
                </div>
              )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={!!values.FilterCommissionId || !!values.by}
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={!!values.FilterCommissionId || !!values.by}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown name="companyId" value={values.companyId} />
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId" value={values.agentId} />
              </div>
              <div className="form-group col-md-3">
                <label>Frontend Manager</label>
                <UserDropDown name="reportingManagerId" value={values.reportingManagerId} />
              </div>
              <div className="form-group col-md-3">
                <label>BackendManager</label>
                <UserDropDown name="reportingManagerBackendId" value={values.reportingManagerBackendId} />
              </div>
              <div className="form-group col-md-6">
                <label>Customer</label>
                <CustomerDropDown name="customerId" value={values.customerId} />
              </div>
              <div className="form-group col-md-3">
                <label>Vehicle Number</label>
                <FormikInput
                  name="vehicleNumber"
                  type="text"
                  placeholder="enter Vehicle Number for filter e.g DLB64620"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={EMPLOYMENT_TYPES_LIST}
                  name="employmentType"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Loan A/C/Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="enter Loan A/C/Policy Number"
                  value={values.LoanPolicyNumber}
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Engine Number</label>
                <FormikInput
                  name="engineNumber"
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Chasis Number</label>
                <FormikInput
                  name="chasisNumber"
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Data entry operater</label>
                <UserDropDown name="by" value={values.by} />

              </div>
              <div className="form-group col-md-6">
                <label>Co Applicant</label>
                <CustomerDropDown name="CoApplicantDetails"
                  value={values.CoApplicantDetails}
                />
              </div>
              {values.by && (
                <>
                  <div className="form-group col-md-3">
                    <label>From Date</label>
                    <FormikDateTimePicker
                      name="CaseTsFromDate"
                      className="form-control"
                      disableClock
                      format="dd-MM-y"
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label>To Date</label>
                    <FormikDateTimePicker
                      name="CaseTsToDate"
                      className="form-control"
                      disableClock
                      format="dd-MM-y"
                    />
                  </div>
                </>
              )}
            </div>

            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="reports.case_list.search"
              />
            </div>
          </Form>
        </div>
      </div>
      <div className="border-top my-3" />
      <div className="card mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"Case-List-" + new Date().toLocaleDateString()}
            />
          </h5>
          <div className="mb-2 border p-2 float-left">
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross Loan Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalGrossAmt || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Net Loan Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalNetAmt || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
          </div>
          <Table
            recordsPerPage={50}
            onPageChange={onPageChange}
            searchData={{
              data: activityList.data,
              count: activityList.count,
              currentPage: activityList.currentPageIndex,
            }}
            columns={{
              group: [
                // {
                //   display: "Loan-Disbursed Date",
                //   type: Date,
                //   format: DATE_TIME_FORMAT.DATE,
                //   path: "meta.loanDate",
                // },
                {
                  display: "Loan Type",
                  path: "meta.loanType",
                },
                {
                  display: "Car Loan Type",
                  path: "meta.usedCarType",
                },
                {
                  display: "Bank/Company Name",
                  path: "companyId.companyName",
                },
                {
                  display: "Loan A/c Number",
                  path: "meta.LoanAccountNo",
                },
                {
                  display: "Policy Number",
                  path: "coverNotes.cn_number",
                },
                {
                  display: "Name Of Customer",
                  path: ["customerId.firstName", "customerId.lastName"],
                },
                {
                  display: "Co Applicant",
                  path: ["CoApplicantDetails[0].customerId.firstName", "CoApplicantDetails[0].customerId.lastName", "CoApplicantDetails[0].customerId.phone"]
                },
                {
                  display: "Cost Of Asset",
                  path: "meta.costOfAsset",
                },
                {
                  display: "Loan Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.loanAmount",
                },
                {
                  display: "Cross Sell Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.crossSaleAmount",
                },
                {
                  display: "Gross Loan Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.grossLoanAmount",
                },
                {
                  display: "EMI Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.EMIAmount",
                },
                {
                  display: "Advance EMI",
                  type: DATA_TYPE.Decimal,
                  path: "meta.EMIAdvance",
                },
                {
                  display: "Tenure",
                  path: "meta.tenure",
                },
                {
                  display: "ROI",
                  type: DATA_TYPE.Decimal,
                  path: "meta.businessIRR",
                },
                {
                  display: "Processing Fees",
                  type: DATA_TYPE.Decimal,
                  path: "meta.processingFees",
                },

                {
                  display: "Disbursed Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.disbursedAmount",
                },
                {
                  display: "Bank Payment Rate(%)",
                  type: DATA_TYPE.Decimal,
                  path: "companyCommissionPercentage",
                },
                {
                  display: 'Agent Payout Rate(%)',
                  type: DATA_TYPE.Decimal,
                  path: 'agentCommissionPercentage',
                },
                // {
                //   display: "Dealer/Showroom",
                //   path: "meta.showroomDealer.companyDisplayName",
                // },
                {
                  display: "Vehicle Number",
                  path: "meta.vehicleNumber",
                },
                {
                  display: "Engine Number",
                  path: "meta.engineNumber",
                },
                {
                  display: "Chasis Number",
                  path: "meta.chasisNumber",
                },
                {
                  display: "Address",
                  path: "customerAddress",
                },
                {
                  display: "Brand Name",
                  path: "meta.vehicleProductId.manufacturer.companyName",
                },
                {
                  display: "Model Name",
                  path: "meta.vehicleProductId.productName",
                },

                {
                  display: "Cubic Capacity",
                  path: "meta.vehicleProductId.meta.cubicCapacity",
                },
                {
                  display: "Fuel Type",
                  path: "meta.vehicleProductId.meta.fuelType",
                },
                // {
                //   display: "Insurance Type",
                //   path: "vehicleStatus",
                // },
                // {
                //   display: "Insurance Plans",
                //   path: "insurancePlans",
                // },
                {
                  display: "Dealer/Showroom",
                  path: "meta.showroomDealer.companyDisplayName",
                },
                {
                  display: "Frontend Manager",
                  path: ["reportingManagerId.personalInfo.firstName", "reportingManagerId.personalInfo.lastName", "reportingManagerId.personalInfo.phone"],
                },
                {
                  display: "Backend Manager",
                  path: ["reportingManagerBackendId.personalInfo.firstName", "reportingManagerBackendId.personalInfo.lastName", "reportingManagerBackendId.personalInfo.phone"],
                },
                {
                  display: "Assigned Agent Name",
                  path: [
                    "agentId.personalInfo.firstName",
                    "agentId.personalInfo.lastName",
                    "agentId.employmentType",
                  ],
                },
                // {
                //     display: 'Payout Amount',
                //     path: 'payoutAmount',
                // },
                {
                  display: "Disbursement Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "meta.loanDate",
                },
              ],
              productId: {
                display: "Product",
                path: "productId.productName",
              },
              InsuranceReceived: {
                display: "Invoice Received",
                path: "meta.invoiceRecv",
              },
              InvoiceReceived: {
                display: "RC Received",
                path: "meta.RCRecv",
              },
              RCReceived: {
                display: "Insurance Received",
                path: "meta.insuranceRec",
              },
              parivahanStatus: {
                display: "Parivahan Status",
                path: "meta.parivahanStatus",
              },
              rtoSlip: {
                display: "RTO Slip Received",
                path: "meta.rtoSlip",
              },
              rcTransferredBy: {
                display: "RC Transferred by",
                path: "rcTransferredBy",
              },
              by: {
                display: "By",
                path: "by.personalInfo.firstName",
              },
              updatedBy: {
                display: "Updated By",
                path: "updatedBy.personalInfo.firstName",
              },
              ts: {
                display: "Ts",
                type: Date,
                format: DATE_TIME_FORMAT.TIMEAGO,
              },
              updatedTs: {
                display: "Updated Ts",
                type: Date,
                format: DATE_TIME_FORMAT.TIMEAGO,
              },
            }}
            rowColoring={[
              // list should be priority wise
              {
                reason: 'Pending',
                rowClass: 'status-pending',
                shouldApply: (record) => (record.isPending),
              },
              {
                reason: 'Critical',
                rowClass: 'status-critical',
                shouldApply: (record) => (record.isCritical),
              },
            ]}
            customActions={[
              {
                heading: "View Remarks",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => viewRemarks(record._id)}>
                      <i className="fas fa-eye " />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Case Manager",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => editClick(record)}>
                      <i className="fas fa-pen" />
                    </LinkComponent>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // activityList: PropTypes.Object.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
  verifierId: "",
  clientId: "",
  branchId: "",
  CaseFromDate: null, //new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseToDate: null, //new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  LoanPolicyNumber: ""
};

const RptCaseList = () => {
  const history = useHistory();
  const { location: { state } } = history;
  let filters = state?.filters || null;

  const [filterInitialValues, setFilterInitialValues] = useState(filters || {
    ...filterDefaultValues,
  });

  const [currentProductCategory, setProductCategory] = useState();

  const [currentCompany, setCurrentCompany] = useState();

  const [currentActivityAssignedDateTill, setCurrentActivityAssignedDateTill] =
    useState();

  const [currentActivityAssignedDateFrom, setCurrentActivityAssignedDateFrom] =
    useState();

  const [invoiceInitialValues, setInvoiceInitialValues] = useState([]);

  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [alertModalClass, setAlertModalClass] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState(false);
  const [remarksModalClass, setRemarksModalClass] = useState(false);
  const [remarksDisplay, setRemarksDisplay] = useState(false);
  const [remarksDetails, setRemarksDetails] = useState([]);
  const [commissionMaster, setCommissionMaster] = useState({ slab: [] });
  const [grossLoan, setGrossLoan] = useState(0)
  const [netLoan, setNetLoan] = useState(0)
  const [total, setTotal] = useState({})

  const openAlertDialog = () => {
    setRemarksDisplay("block");
    setRemarksModalClass("show");
    if (document.body.style.overflow !== "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };
  const closeAlertDialog = () => {
    setRemarksModalClass("none");
    setRemarksDisplay("");
    if (document.body.style.overflow !== "scroll") {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
  };

  let data = [];
  // REDUX
  const dispatch = useDispatch();
  useEffect(() => {
    if (filters) {
      onSearchSubmit(filters)
    }
    return () => {
      filters = null
    }
  }, [filters])

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.CaseReducer, shallowEqual);

  const {
    search: { data: excelSearchResults, excelCount },
  } = useSelector((state) => state.ExcelReducer, shallowEqual);

  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );


  const getCommissionDetails = (totalGrossAmt) => {
    let commissionDT = []; //{ commissionTarget: 0, tillNow: 0, Status: "Short" };
    commissionMaster.slab.map((slab, index) => {
      // const lastTarget = commissionMaster.slab[index];
      const status = totalGrossAmt >= slab.target ? "Completed" : "Short";
      const amount = slab.target + (slab.target * slab.reward) / 100;
      commissionDT.push({
        commissionTarget: slab.target,
        tillNow: totalGrossAmt,
        reward: slab.reward,
        amount,
        status,
        isRewardPercentage: slab.isRewardPercentage,
      });
    });
    return isNaN(commissionDT) ? 0 : commissionDT;
  };

  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }
    const PrepairData = [];
    let totalGrossAmt = 0;
    let totalNetLoan = 0;
    let customerAddress = "NA"
    searchResults.forEach((caseInfo) => {
      if (caseInfo?.caseType == "CORPORATE") {
        customerAddress = caseInfo?.customerId?.companyAddress
      } else {
        customerAddress = caseInfo?.customerId?.presentAddress
      }
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      setGrossLoan(totalGrossAmt)
      totalNetLoan += caseInfo.meta.loanAmount - caseInfo.meta.crossSaleAmount - caseInfo.meta.processingFees;
      if (!isNaN(totalNetLoan)) {
        setNetLoan(totalNetLoan)
      }
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const currentDate = new Date();
      const otherDate = new Date(caseInfo.meta.loanDate);
      const timeDifference = Math.abs(currentDate.getTime() - otherDate.getTime());
      const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24));

      const isPending = ((
        !caseInfo.meta.RCRecv ||
        !caseInfo.meta.insuranceRec ||
        !caseInfo.meta.invoiceRecv ||
        !caseInfo.meta.parivahanStatus ||
        !caseInfo.meta.rtoSlip) && (
          ((new Date() - new Date(caseInfo.meta.loanDate)) >= 30 * 24 * 60 * 60 * 1000) &&
          ((new Date() - new Date(caseInfo.meta.loanDate)) <= 60 * 24 * 60 * 60 * 1000))
      );
      const isCritical = ((
        !caseInfo.meta.RCRecv ||
        !caseInfo.meta.insuranceRec ||
        !caseInfo.meta.invoiceRecv ||
        !caseInfo.meta.parivahanStatus ||
        caseInfo.meta.rtoSlip) && (
          ((new Date() - new Date(caseInfo.meta.loanDate)) >= 61 * 24 * 60 * 60 * 1000))
      );

      PrepairData.push({
        ...caseInfo,
        difference,
        payoutAmount,
        DueAmount,
        CrossSellAmount,
        GSTEncExc,
        agentName,
        amount,
        paymentAmount,
        receiptAmount,
        loanType,
        customerName,
        customerAddress,
        isPending,
        isCritical,
        dayCount
      });
    });

    const commissionDetails = getCommissionDetails(totalGrossAmt);
    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
      commissionDetails,
    };

    return results;
  }, [
    searchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
    currentPageIndex,
  ]);

  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        caseSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      caseSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values) => {
      // formikUtils.setSubmitting(false);
      const {
        productCategory,
        loanType,
        usedCarLoanType,
        CaseFromDate,
        CaseToDate,
        companyId,
        agentId,
        reportingManagerId,
        reportingManagerBackendId,
        FilterCommissionId,
        customerId,
        vehicleNumber,
        employmentType,
        LoanPolicyNumber,
        engineNumber,
        chasisNumber,
        grossLoan,
        CoApplicantDetails,
        customerAddress,
        netLoan,
        customerFirstName,
        updatedBy,
        by,
        CaseTsFromDate,
        CaseTsToDate
      } = values;

      // Check if CaseFromDate and CaseToDate are present
      // if (!CaseFromDate || !CaseToDate) {
      //   dispatch(
      //     headerShowAction({
      //       data: "CaseFromDate and CaseToDate are required filters.",
      //     })
      //   );
      //   return;
      // }

      if (
        // THERE MUST BE AT LEAST ONE FILTER
        [
          productCategory,
          loanType,
          usedCarLoanType,
          CaseFromDate,
          CaseToDate,
          companyId,
          FilterCommissionId,
          agentId,
          reportingManagerId,
          reportingManagerBackendId,
          customerId,
          vehicleNumber,
          employmentType,
          LoanPolicyNumber,
          engineNumber,
          chasisNumber,
          grossLoan,
          CoApplicantDetails,
          customerAddress,
          netLoan,
          customerFirstName,
          updatedBy,
          by,
          CaseTsFromDate,
          CaseTsToDate,
        ].filter((item) => !!item).length < 1
      ) {
        dispatch(
          headerShowAction({
            data: "There must at least one filter to be added.",
          })
        );
        return;
      }

      let where = {};

      // product Category
      if (productCategory) {
        set(where, "productCategory", productCategory);
        setProductCategory(productCategory);
      } else {
        setProductCategory(null);
      }

      if (loanType) {
        set(where, "meta.loanType", loanType)
      }
      if (usedCarLoanType)
        set(where, "meta.usedCarType", usedCarLoanType)
      // company
      if (companyId) {
        set(where, "companyId", companyId);
        setCurrentCompany(companyId);
      } else {
        setCurrentCompany(null);
      }

      // FROM
      if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateFrom(CaseFromDate);
        set(where, "meta.loanDate", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }

      // TILL
      if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
        const tillDate = getEndOfDay(CaseToDate);
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateTill(CaseToDate);

        set(where, "meta.loanDate", { $lte: tillDate });
        if (fromDate)
          set(where, "meta.loanDate", { $lte: tillDate, $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateTill(null);
      }
      //ts from
      if (CaseTsFromDate && !Number.isNaN(CaseTsFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseTsFromDate);
        setCurrentActivityAssignedDateFrom(CaseTsFromDate);
        console.log('where', where)
        set(where, "ts", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }
      //ts till
      if (CaseTsToDate && !Number.isNaN(CaseTsToDate.getTime())) {
        const tillDate = getEndOfDay(CaseTsToDate);
        const fromDate = CaseTsFromDate && !Number.isNaN(CaseTsFromDate.getTime()) ? getStartOfDay(CaseTsFromDate) : null;

        setCurrentActivityAssignedDateTill(CaseTsToDate);

        if (fromDate) {
          set(where, "ts", { $lte: tillDate, $gte: fromDate });
        } else {
          set(where, "ts", { $lte: tillDate });
        }
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      // CLIENT
      if (agentId) {
        where.agentId = agentId;
      }
      if (reportingManagerId) {
        where.reportingManagerId = reportingManagerId;
      }
      if (reportingManagerBackendId) {
        where.reportingManagerBackendId = reportingManagerBackendId;
      }

      //CUSTOMER
      if (customerId) {
        where.customerId = customerId;
      }
      //Engine Number
      if (engineNumber) {
        set(where, "meta.engineNumber", engineNumber);
      }
      //Chasis Number
      if (chasisNumber) {
        console.log('where', where)
        set(where, "meta.chasisNumber", chasisNumber);
      }

      if (customerFirstName) {
        where.customerId.firstName = customerFirstName;
      }
      if (by) {
        set(where, "by", by);
      }

      // if(customerAddress){
      //   set(where, "companyId.presentAddress", 
      //   //customerAddress)
      //  //{ $regex: `.*${customerAddress}.*`, $options: "i" });
      //   { $regex: `${customerAddress}`, $options: "i"  });

      // }

      //COAPPLICANT
      if (CoApplicantDetails) {
        set(where, "CoApplicantDetails[0].customerId", CoApplicantDetails)
      }

      //Vehicle Number
      if (vehicleNumber) {
        const lastFourDigits = vehicleNumber.slice(-4);
        set(where, "meta.vehicleNumber", { $regex: `${lastFourDigits}` });
      }
      // CommissionId
      if (FilterCommissionId) {
        where = {};
        set(where, "invoiceDetails.commissionId", FilterCommissionId);
        const commissionId = { _id: FilterCommissionId };
        let {
          data: {
            data: { data: commissionMasterDT },
          },
        } = await commissionSearchAPI({
          where: {
            ...commissionId,
          },
          autopopulate: false,
        });
        commissionMasterDT = commissionMasterDT[0];
        setCommissionMaster(commissionMasterDT);
        const fromDate = getStartOfDay(commissionMasterDT.FromDate);
        set(where, "ts", { $gte: fromDate });
        setCurrentActivityAssignedDateFrom(fromDate);
        values.CaseFromDate = fromDate;
        const tillDate = getEndOfDay(commissionMasterDT.ToDate);
        set(where, "ts", { $lte: tillDate });
        setCurrentActivityAssignedDateTill(tillDate);
        values.CaseToDate = tillDate;

        if (commissionMasterDT.loanType)
          set(where, "loanType", commissionMasterDT.loanType);
        if (
          commissionMasterDT.loanType == "USED" &&
          commissionMasterDT.usedCarType
        )
          set(where, "usedCarType", commissionMasterDT.usedCarType);
      } else {
        // setCurrentCompany(null);
      }

      if (employmentType) {
        const fetchUserIds = async (type, currentPage = 0) => {
          let allUserIds = [];
          let { data: { data: { data: userIdsChunk, pages } } } = await userSearchAPI({
            where: { employmentType: type },
            currentPage,
          });

          allUserIds = [...allUserIds, ...userIdsChunk.map(user => user._id)];
          const totalPages = pages;
          if (currentPage < totalPages) {
            const remainingUserIds = await fetchUserIds(type, currentPage + 1);
            allUserIds = [...allUserIds, ...remainingUserIds];
          }

          return allUserIds;
        };
        const getUserIds = async (employmentType) => {
          if (employmentType === "onroll&dsa") {
            const onRollUserIds = await fetchUserIds("ON_ROLL");
            const dsaUserIds = await fetchUserIds("DSA");
            return [...onRollUserIds, ...dsaUserIds];
          }
          return await fetchUserIds(employmentType);
        };

        const userIds = await getUserIds(employmentType);

        set(where, "agentId", { $in: userIds });
      }

      //LoanPolicyNumber
      if (LoanPolicyNumber) {
        if (productCategory === "VEHICLE_INSURANCE")
          set(where, "coverNotes.cn_number", LoanPolicyNumber)
        else
          set(where, "meta.LoanAccountNo", LoanPolicyNumber)
      }

      setWhere(where);
      pipeline(where);
      dispatch(
        excelCaseSearchAction({
          where,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
        })
      );
      dispatch(
        caseSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );
  const pipeline = async (where) => {

    // // Stage 2: Calculate payoutAmount
    // const calculatePayoutStage = {
    //   $addFields: {
    //     payoutAmount: {
    //       $switch: {
    //         branches: [
    //           {
    //             case: {
    //               $eq: ["$companyDoc.payOut", "LoanAmtCrossSale"]
    //             },
    //             then: {
    //               $round: {
    //                 $multiply: [
    //                   {
    //                     $sum: [
    //                       "$meta.loanAmount",
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           {
    //                             $multiply: [
    //                               "$meta.EMIAmount",
    //                               "$meta.EMIAdvance"
    //                             ]
    //                           }
    //                         ]
    //                       },
    //                       "$meta.crossSaleAmount"
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$agentCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]                 
    //               }
    //             }
    //           },
    //           {
    //             case: {
    //               $eq: ["$companyDoc.payOut", "LoanAmtLessPF"]
    //             },
    //             then: {
    //               $round:{

    //                 $multiply: [
    //                   {
    //                     $sum: [
    //                       "$meta.loanAmount",
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           {
    //                             $sum: [
    //                               {
    //                                 $multiply: [
    //                                   "$meta.EMIAmount",
    //                                   "$meta.EMIAdvance"
    //                                 ]
    //                               }
    //                             ]
    //                           }
    //                         ]
    //                       },
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           "$meta.processingFees"
    //                         ]
    //                       }
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$agentCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]
    //                     }

    //             }
    //           },
    //           {
    //             case: {
    //               $eq: ["$companyDoc.payOut", "LoanAmt"]
    //             },
    //             then: {
    //               $round: {

    //                 $multiply: [
    //                   {
    //                     $sum: [
    //                       "$meta.loanAmount",
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           {
    //                             $multiply: [
    //                               "$meta.EMIAmount",
    //                               "$meta.EMIAdvance"
    //                             ]
    //                           }
    //                         ]
    //                       }
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$agentCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]
    //                   }

    //             }
    //           },
    //           {
    //             case: {},
    //             then: { 
    //               $round: {
    //                 $multiply: [
    //                   {
    //                     $subtract: [
    //                       {
    //                         $sum: [
    //                           "$meta.loanAmount",
    //                           "$meta.crossSaleAmount"
    //                         ]
    //                       },
    //                       {
    //                         $sum: [
    //                           {
    //                             $multiply: [
    //                               "$meta.EMIAmount",
    //                               "$meta.EMIAdvance"
    //                             ]
    //                           },
    //                           "$meta.processingFees"
    //                         ]
    //                       }
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$agentCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]
    //               }
    //             }
    //           }
    //         ],
    //         default: 0
    //       }
    //     }
    //   }
    // };
    // // Stage 3: Calculate existing amount for payoutAmount
    // const calculateExistingAmountForPayout={
    //   $addFields:{
    //     existingAmountForPayout: {
    //       $cond: [
    //         { $ifNull: ["$paymentDetails", true] },
    //         0,
    //         {
    //           $reduce: {
    //             input: "$paymentDetails",
    //             initialValue: 0,
    //             in: { $sum: ["$$value", "$$this.amount"] }
    //           }
    //         }
    //       ]
    //     }
    //   }

    // }
    // // Stage 4: Calculate grand total payoutAmount
    // const calculatePayoutAmountStage = {
    //   $addFields: {
    //     finalPayoutAmount: { $subtract: ["$payoutAmount", "$existingAmountForPayout"] }
    //   }
    // };
    // // Stage 5: Calculate dueAmount
    // const calculateDueAmount = {
    //   $addFields: {
    //     dueAmount: {
    //       $switch: {
    //         branches: [
    //           {
    //             case: {
    //               $eq: ["$companyDoc.payOut", "LoanAmtCrossSale"]
    //             },
    //             then: {
    //               $round: {
    //                 $multiply: [
    //                   {
    //                     $sum: [
    //                       "$meta.loanAmount",
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           {
    //                             $multiply: [
    //                               "$meta.EMIAmount",
    //                               "$meta.EMIAdvance"
    //                             ]
    //                           }
    //                         ]
    //                       },
    //                       "$meta.crossSaleAmount"
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$companyCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]             
    //               }
    //             }
    //           },
    //           {
    //             case: {
    //               $eq: ["$companyDoc.payOut", "LoanAmtLessPF"]
    //             },
    //             then: {
    //               $round:{

    //                 $multiply: [
    //                   {
    //                     $sum: [
    //                       "$meta.loanAmount",
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           {
    //                             $sum: [
    //                               {
    //                                 $multiply: [
    //                                   "$meta.EMIAmount",
    //                                   "$meta.EMIAdvance"
    //                                 ]
    //                               }
    //                             ]
    //                           }
    //                         ]
    //                       },
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           "$meta.processingFees"
    //                         ]
    //                       }
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$companyCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]
    //                     }

    //             }
    //           },
    //           {
    //             case: {
    //               $eq: ["$companyDoc.payOut", "LoanAmt"]
    //             },
    //             then: {
    //               $round: {
    //                 $multiply: [
    //                   {
    //                     $sum: [
    //                       "$meta.loanAmount",
    //                       {
    //                         $multiply: [
    //                           -1,
    //                           {
    //                             $multiply: [
    //                               "$meta.EMIAmount",
    //                               "$meta.EMIAdvance"
    //                             ]
    //                           }
    //                         ]
    //                       }
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$companyCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]
    //                   }

    //             }
    //           },
    //           {
    //             case: {},
    //             then: { 
    //               $round: {
    //                 $multiply: [
    //                   {
    //                     $subtract: [
    //                       {
    //                         $sum: [
    //                           "$meta.loanAmount",
    //                           "$meta.crossSaleAmount"
    //                         ]
    //                       },
    //                       {
    //                         $sum: [
    //                           {
    //                             $multiply: [
    //                               "$meta.EMIAmount",
    //                               "$meta.EMIAdvance"
    //                             ]
    //                           },
    //                           "$meta.processingFees"
    //                         ]
    //                       }
    //                     ]
    //                   },
    //                   {
    //                     $divide: [
    //                       "$companyCommissionPercentage",
    //                       100
    //                     ]
    //                   }
    //                 ]
    //               }
    //             }
    //           }
    //         ],
    //         default: 0
    //       }
    //     }
    //   }
    // };
    // // Stage 6: Calculate existing amount for due
    // const calculateExistingAmountForDue={
    //   $addFields:{
    //     existingAmountForDue: {
    //       $cond: [
    //         { $ifNull: ["$recieptDetails", true] },
    //         0,
    //         {
    //           $reduce: {
    //             input: "$recieptDetails",
    //             initialValue: 0,
    //             in: { $sum: ["$$value", "$$this.amount"] }
    //           }
    //         }
    //       ]
    //     }
    //   }

    // }
    // // Stage 7: Calculate grand total dueAmount
    // const calculateDueAmountStage = {
    //   $addFields: {
    //     finalDueAmount: { $subtract: ["$dueAmount", "$existingAmountForDue"] }
    //   }
    // };
    // Stage 8: Group and calculate totals
    const groupStage = {
      $group: {
        _id: null,
        totalGrossAmt: {
          $sum: {
            $ifNull: ['$meta.grossLoanAmount', 0]
          }
        },
        totalNetAmt: {
          $sum: {
            $subtract: [
              '$meta.loanAmount',
              {
                $add: ['$meta.crossSaleAmount', '$meta.processingFees']
              }
            ]
          }
        },
        // totalPayoutAmount: {
        //   $sum: "$finalPayoutAmount"
        // },
        // totalExistingAmountForPayout:{
        //   $sum: '$existingAmountForPayout'
        // },
        // totalDueAmount: {
        //   $sum: "$finalDueAmount"
        // },
        // totalExistingAmountForDue:{
        //   $sum: '$existingAmountForDue'
        // },
        count: { $sum: 1 },
      }
    };
    // Stage 9: Project required fields
    const projectStage = {
      $project: {
        _id: 0,
        totalGrossAmt: 1,
        totalNetAmt: 1,
        // totalPayoutAmount: 1,
        // totalExistingAmountForPayout:1,
        // totalDueAmount: 1,
        // totalExistingAmountForDue:1,
        count: 1
      }
    };
    // Combine all stages into the pipeline array
    const pipelineStages = [
      // calculatePayoutStage,
      // calculateExistingAmountForPayout,
      // calculatePayoutAmountStage,
      // calculateDueAmount,
      // calculateExistingAmountForDue,
      // calculateDueAmountStage,
      groupStage,
      projectStage
    ];

    const pipelineHelper = {
      where,
      pipelineStages
    }
    let {
      data: {
        data: [totalPipe]
      }
    } = await pipelineApi(pipelineHelper);
    setTotal(totalPipe)
  }
  // const onCommissionSubmit = useCallback(async (
  //     values,
  //     formikUtils,
  // ) => {
  //     formikUtils.setSubmitting(false);
  //     const {
  //         FilterCommissionId,
  //     } = values;

  //     let where = {
  //     };

  //     // FROM
  //     if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
  //         const fromDate = getStartOfDay(CaseFromDate);
  //         setCurrentActivityAssignedDateFrom(CaseFromDate);
  //         set(where, 'ts', { $gte: fromDate });
  //     }
  //     else {
  //         setCurrentActivityAssignedDateFrom(null);
  //     }

  //     // TILL
  //     if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
  //         const tillDate = getEndOfDay(CaseToDate);
  //         setCurrentActivityAssignedDateTill(CaseToDate);
  //         set(where, 'ts', { $lte: tillDate });
  //     }
  //     else {
  //         setCurrentActivityAssignedDateTill(null);
  //     }
  //     //FilterCommissionId
  //     if(FilterCommissionId)
  //     {
  //         set(where, 'ts', { $lte: tillDate });
  //     }
  //     setWhere(where);
  //     dispatch(caseSearchAction({
  //         where,
  //         currentPage: 0,
  //         sortBy: 'ts',
  //         sortOrder: -1,
  //         fullTextSearch: false,
  //         pageLength: 10,
  //     }));
  // }, [
  //     dispatch,
  // ]);

  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const generateInvoice = useCallback(
    async (commissionId) => {
      const payload = {
        commissionId: commissionId,
        data: invoiceInitialValues,
      };
      const invoice = await caseInvoiceCreateAPI(payload);
      closeAlertDialog();
      dispatch(
        headerShowAction({
          data: "Invoice has been created successfully.",
        })
      );
    },
    [invoiceInitialValues]
  );
  const handleChange = useCallback(
    (e) => {
      const id = e.target.name;
      const checked = e.target.value;

      if (checked == "false")
        setInvoiceInitialValues([...invoiceInitialValues, id]);
      else
        setInvoiceInitialValues(
          invoiceInitialValues.filter((item) => {
            return id !== item;
          })
        );

      // setInvoiceInitialValues(id)

      // // data.push(id);
      // console.log("checked", checked);
      // console.log("invoiceInitialValues=>", invoiceInitialValues);
      // // if()
      // else
      // console.log('invoiceInitialValues=>', invoiceInitialValues, data);

      return data;
    },
    [
      // dispatch,
      invoiceInitialValues,
    ]
  );

  const ExportInExcel = useMemo(() => {
    if (!excelSearchResults) {
      return [];
    }
    const results = [];
    let totalGrossAmt = 0;

    excelSearchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo.agentId?.personalInfo?.firstName +
        " " +
        caseInfo.agentId?.personalInfo?.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const loanDate = new Date(caseInfo.meta.loanDate)
      const firsttEMI = new Date(caseInfo.meta.firstEMI)
      const lastEMI = new Date(caseInfo.meta.LastEMIDate)
      const disbursmentDate = new Date(caseInfo.meta.loanDate)
      const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };
      const formattedLoanDate = loanDate.toLocaleDateString('en-GB', dateOptions);
      const formattedFirstEMIDate = firsttEMI.toLocaleDateString('en-GB', dateOptions);
      const formattedLastEMIDate = lastEMI.toLocaleDateString('en-GB', dateOptions);
      const formattedDisbusmentDate = disbursmentDate.toLocaleDateString('en-GB', dateOptions);
      const formattedDate = new Date(caseInfo.ts).toLocaleDateString('en-GB', dateOptions);

      results.push({
        "Loan Date": formattedLoanDate,
        "Loan Type": loanType,
        // "Car Loan Type": caseInfo.meta.usedCarType,
        "Loan A/c/Policy Number": caseInfo.meta.LoanAccountNo,
        "Loan Amount": caseInfo.meta.loanAmount,
        "EMI Amount": caseInfo.meta.EMIAmount,
        Tenure: caseInfo.meta.tenure,
        ROI: caseInfo.meta.businessIRR,
        "Processing Fees": caseInfo.meta.processingFees,
        "Disbursed Amount": caseInfo.meta.disbursedAmount,
        "Dealer/Showroom": caseInfo.meta?.showroomDealer?.companyDisplayName,
        "First EMI": formattedFirstEMIDate,
        "Last EMI Date": formattedLastEMIDate,
        "Bank/Company Name": caseInfo.companyId.companyName,
        "Name of Customer": customerName,
        "Customer Mobile": caseInfo.customerId.phone,
        "Model Name": caseInfo.meta.vehicleProductId.productName,
        "Cost Of Asset": caseInfo.meta.costOfAsset,
        "Cross Sell Amount": CrossSellAmount,
        "Gross Loan Amount": caseInfo.meta.grossLoanAmount,
        "Advance EMI": caseInfo.meta.EMIAdvance,
        "Vehicle Number": caseInfo.meta.vehicleNumber,
        "Invoice Received": caseInfo.meta.invoiceRecv === true ? "YES" : "NO",
        "RC Received": caseInfo.meta.RCRecv === true ? "YES" : "NO",
        "Insurance Received":
          caseInfo.meta.insuranceRec === true ? "YES" : "NO",
        "Parivahan Status":
          caseInfo.meta.parivahanStatus === true ? "YES" : "NO",
        "RTO Slip Received": caseInfo.meta.rtoSlip === true ? "YES" : "NO",
        "Assigned Agent Name":
          caseInfo.agentId.personalInfo.firstName +
          " " +
          caseInfo.agentId.personalInfo.lastName,
        "Frontend Manager Name":
          caseInfo.reportingManagerId.personalInfo.firstName + " " +
          caseInfo.reportingManagerId.personalInfo.lastName,
        "Backend Manager Name":
          caseInfo.reportingManagerBackendId?.personalInfo.firstName + " " +
          caseInfo.reportingManagerBackendId?.personalInfo.lastName,
        "Amount": amount,
        "Agent Payout Rate(%)": caseInfo.agentCommissionPercentage,
        // "Payout Amount": payoutAmount,
        // "Paid Amount": caseInfo.paymentAmount,
        // "Disbursement Date": formattedDisbusmentDate,
        "Bank Payment Rate": caseInfo.companyCommissionPercentage,
        // "Due Amount": DueAmount,
        // "Received Amount": receiptAmount,
        // "GST(Inc/Exc)": GSTEncExc,
        // "Difference": difference,
        "Created By": caseInfo.by.personalInfo.firstName,
        Date: formattedDate,
      });
    });

    return results;
  }, [
    excelSearchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
  ]);
  const viewRemarks = async (id) => {
    openAlertDialog("remarks");
    if (!id) return;

    let where = {
      refId: id,
      deleted: false,
      source: "cases",
    };

    const {
      data: {
        data: { data: remarks },
      },
    } = await remarkSearchAPI({
      where,
      sortBy: "ts",
      pageLength: 0,
      currentPage: 1,
      autopopulate: false,
    });
    setRemarksDetails(remarks);
  };

  // EDIT
  const editClick = useCallback((record) => {
    dispatch(caseEditAction(record));
    history.push(RoutingUtil.caseManagerUrl());
  }, [
    dispatch,
    caseEditAction,
    history,
  ]);

  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
      // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            activityList={activitiesFromSearch}
            userType={userType}
            ExportInExcel={ExportInExcel}
            handleChange={handleChange}
            generateInvoice={generateInvoice}
            history={history}
            onPageChange={onPageChange}
            alertModalClass={alertModalClass}
            alertDisplay={alertDisplay}
            openAlertDialog={openAlertDialog}
            viewRemarks={viewRemarks}
            editClick={editClick}
            grossLoan={grossLoan}
            netLoan={netLoan}
            total={total}
          />
        )}
      </Formik>
      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${remarksModalClass}`}
        id="authAlert"
        style={{
          display: `${remarksDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Remarks
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("remarks")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {remarksDetails.map((remark, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{remark.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("remarks")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RptCaseList;
